const prefix = "PROVIDER_CONTACT_";

export const LIST_SET_FILTERS = prefix + "LIST_SET_FILTERS";
export const LIST_STARTED = prefix + "LIST_STARTED";
export const LIST_SUCCEEDED = prefix + "LIST_SUCCEEDED";
export const LIST_FAILED = prefix + "LIST_FAILED";
export const FLAG_AS_PRIMARY_STARTED = prefix + "FLAG_AS_PRIMARY_STARTED";
export const FLAG_AS_PRIMARY_SUCCEEDED = prefix + "FLAG_AS_PRIMARY_SUCCEEDED";
export const FLAG_AS_PRIMARY_FAILED = prefix + "FLAG_AS_PRIMARY_FAILED";
export const LIST_SET_PAGING = prefix + "LIST_SET_PAGING";
export const LIST_TOGGLE_EXPAND = prefix + "LIST_TOGGLE_EXPAND";
export const STATE_UNLOAD = prefix + "STATE_UNLOAD";
export const STATE_RESET = prefix + "STATE_RESET";
export const GET_STARTED = prefix + "GET_STARTED";
export const GET_SUCCEEDED = prefix + "GET_SUCCEEDED";
export const GET_FAILED = prefix + "GET_FAILED";
export const SET_STATUS_STARTED = prefix + "SET_STATUS_STARTED";
export const SET_STATUS_SUCCEEDED = prefix + "SET_STATUS_SUCCEEDED";
export const SET_STATUS_FAILED = prefix + "SET_STATUS_FAILED";
